<template>
  <app-layout>
    <v-card class="ma-3">
      <v-card-title>
        <h2>Contratos de Trabajadores</h2>
      </v-card-title>
      <v-card-text>
        <workers :admin-view="true"></workers>
      </v-card-text>
    </v-card>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import Workers from '@/modules/laboral/components/Workers.vue';

export default {
  components: { Workers, AppLayout },
  computed: {
    codempre() {
      return 1;
    },
  },
};
</script>

<style></style>
